import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const LOGO_URL = process.env.REACT_APP_LOGO_URL;

export function IntroOverlay() {
  const [show, setShow] = useState(() => !sessionStorage.getItem('bb_intro_seen'));
  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      sessionStorage.setItem('bb_intro_seen', '1');
      setShow(false);
    }, 1700);
    return () => clearTimeout(t);
  }, [show]);
  if (!show) return null;
  return (
    <div className="intro-overlay" aria-hidden="true">
      <img src={LOGO_URL} alt="" className="intro-logo" />
    </div>
  );
}

export function PageTransition({ children }) {
  const location = useLocation();
  const [animKey, setAnimKey] = useState(location.pathname);
  const [sweep, setSweep] = useState(false);

  useEffect(() => {
    setAnimKey(location.pathname);
    setSweep(true);
    const t = setTimeout(() => setSweep(false), 950);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <>
      {sweep && <div className="page-sweep" aria-hidden="true" />}
      <div key={animKey} className="page-transition">
        {children}
      </div>
    </>
  );
}
